import useFeatureFlag from "../../../graphql/hooks/useFeatureFlag";

export const useAgenticIntakeEnabled = () => {
  return useFeatureFlag("ai_interviewer:agentic_intake");
};
